import React from 'react';
import './App.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import MyHardwareList from './pages/MyHardwareList';
import LandingPage from './pages/LandingPage';
import HardwarePerformance from './pages/HardwarePerformance';
import AboutPage from './pages/AboutPage';
import GamesPage from './pages/GamesPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import RankingPage from './pages/RankingPage';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    overflow-x: hidden;
    width: 100%;
    position: relative;
  }
`;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, 
      gcTime: 30 * 60 * 1000,   
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <GlobalStyle />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/mySpec" element={<MyHardwareList />} />
          <Route path="/hardware-performance" element={<HardwarePerformance />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="/hardware-ranking" element={<RankingPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
